import { gql } from '@apollo/client';

export const ChangePass = gql`
    mutation changePassword($email: String!, $code: String!, $password1: String!, $password2: String!) {
        changePassword(email: $email, code: $code, password1: $password1, password2: $password2) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
